
import { Component, Injector, NgZone } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { Dashboard } from '../dashboard/dashboard';
import { UserLogin } from '../user-login/user-login';
import { UserForgotpassword } from '../user-forgotpassword/user-forgotpassword';
import { Util } from '../../app/util';
import { HrListCampionatiPage } from '../hr_listcampionati/hr_listcampionati';
import { TranslateService } from '@ngx-translate/core';
import { EthemeProvider } from '../../providers/etheme/etheme';
var docsrc = '';

@IonicPage()
@Component({
  selector: 'page-hr_caricautente',
  templateUrl: 'hr_caricautente.html',
})
export class HrCaricaUtente extends Util {
  params_grafici: any = {};
  grafici: any = null;
  private captchaPassed: boolean = false;
  private captchaResponse: string;
  photoName: string = '';
  fileExtension: any;
  fileExtensionError: boolean;
  fileExtensionMessage: string = '';
  err: string;
  campionato_id: any;
  squadre = [];
  dichiarazione_ok: boolean = false;
  email_invito_checkbox: boolean = false;
  params: any = { nome: '', cognome: '', email: '', username: '', password: '', rpassword: '', data_nascita: '', azienda: '', area: '', filiale: '', ruolo: '', campionato_id: '', abilitato: '', luogo_nascita: '', ateco: '', campo: '', Squadra_id: '' };
  constructor(public navCtrl: NavController, public translate: TranslateService, public navParams: NavParams, injector: Injector, private zone: NgZone, public etheme: EthemeProvider) {
    super(injector, null);
    this.campionato_id = this.navParams.get('campionato');
    this.params_grafici = this.navParams.get('params_grafici'); 
    console.log(this.params_grafici);
    // console.log(this.etheme.theme_selected);
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad UserSignup');
    // this.squadre = [{nome:'tigri',id:20},{nome:'leoni',id:21}];
    this.GetRequest('hr_squadre_campionato', this.campionato_id, true, false).then((sq) => {
      if (sq != null && sq['SquadraList'] != null)
        this.squadre = sq['SquadraList'];
    }).catch((err) => {
      console.error(err);
    })
  }

  haSediciCaratteri(testo: string): boolean {
    return testo.length === 16;
  }

  captchaResolved(response: string): void {

    this.zone.run(() => {
      this.captchaPassed = true;
      this.captchaResponse = response;
    });

  }
  dashboardPage() { this.navCtrl.push(Dashboard); }
  loginPage() { this.navCtrl.push(UserLogin); }
  forgotPasswordPage() { this.navCtrl.push(UserForgotpassword); }
  go_root() {
    this.navCtrl.setRoot(HrListCampionatiPage);
  }
  back() {
    // if(this.refresh_dashboard == false)
    this.navCtrl.pop({ animate: false });
    // else
    //   this.go_root();
  }


  signup() {
    this.translate.get(['hr.CARICAMENTOUTENTEUPDATE', 'hr.CARICAMENTOOKUPDATE', 'hr.NOMEOBB', 'hr.CFCARATTERI', 'hr.COGNOMEOBB', 'hr.USERNAMEOBB', 'hr.CFOBB', 'hr.EMAILOBB', 'hr.PASSOBB', 'hr.CONFPASS', 'hr.CONFPASSUGUALE', 'hr.DATANASCITAOBB', 'hr.SQUADRACAMPO', 'hr.CARICAMENTOUTENTE', 'hr.CARICAMENTOOK']).subscribe(v => {
      this.err = '';
      if (this.params.nome == '')
        this.err += '- ' + v['hr.NOMEOBB'] + '<br>';
      if (this.params.cognome == '')
        this.err += '- ' + v['hr.COGNOMEOBB'] + '<br>';

      if (this.params.username == '') {

        if (this.etheme.theme_selected != 'ejoy-theme') {
          this.err += '- ' + v['hr.USERNAMEOBB'] + '<br>';
        } else {
          this.err += '- ' + v['hr.CFOBB'] + '<br>'
        }
      }
      if (this.params.email == '')
        this.err += '- ' + v['hr.EMAILOBB'] + '<br>';
      if (this.params.password == '')
        this.err += '- ' + v['hr.PASSOBB'] + '<br>';
      if (this.params.rpassword == '')
        this.err += '- ' + v['hr.CONFPASS'] + '<br>';
      if (this.params.rpassword != this.params.password)
        this.err += '- ' + v['hr.CONFPASSUGUALE'] + '<br>';
      if (this.params.data_nascita == '' && this.etheme.theme_selected != 'ejoy-theme')
        this.err += '- ' + v['hr.DATANASCITAOBB'] + '<br>';
      if (!this.params.Squadra_id)
        this.err += '- ' + v['hr.SQUADRACAMPO'] + '<br>';
      if (this.dichiarazione_ok == false)
        this.err += '- Devi accettare la dichiarazione<br>';
      
      if(this.etheme.theme_selected == 'ejoy-theme' && this.params.username != ''){
        if(!this.haSediciCaratteri(this.params.username)){
          this.err += '- ' + v['hr.CFCARATTERI'] + '<br>';
        }

      }


      /*else {
        if (docsrc == '') {
          this.err += '- Devi caricare la foto di un documento di identità<br>';
        }
        if (this.fileExtensionMessage != '') {
          this.err += this.fileExtensionMessage + '<br>';
        }
      }*/
      /*if (this.params.privacy == false) {
        this.err += '- Non hai accettato l\'informativa sulla Privacy e le consizioni di utilizzo<br>';
      }*/
      /*if (this.captchaPassed == false) {
        this.err += '- Non hai dichiarato di non essere un robot<br>';
      }*/


      if (this.err == '') {


        if (this.etheme.theme_selected == 'ejoy-theme') {
          this.params.cf = this.params.username;
        }
        //this.params.documento = docsrc;
        if(this.email_invito_checkbox){
          this.params['inviaInvito'] = true;
        }
        else {
          this.params['inviaInvito'] = false;
        }
        this.params.abilitato = true;
        this.params.campionato_id = this.campionato_id;
        this.PostRequest('hr_utente', '', this.params).then((data) => {

          if (data['exists'] != null) {
            this.showBasicAlert(v['hr.CARICAMENTOUTENTEUPDATE'], v['hr.CARICAMENTOOKUPDATE']);
          }
          else {
            this.showBasicAlert(v['hr.CARICAMENTOUTENTE'], v['hr.CARICAMENTOOK']);
          }

          /*this.PostRequest('logout', null, null).then(data => {
          }).catch(err => {
            console.error(err);
          });*/
          //this.storage.clear();
          this.back();
          //window.location.reload();
        }).catch(err => {
          console.error(err);
          //this.showBasicAlert('Errore',err)
        });
      }
      else {
        this.showBasicAlert('Errore', this.err);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/hr_caricautente/hr_caricautente.ts